import { useEffect } from "react";
import { useTable, useSortBy } from "react-table";
import cx from "classnames";

function Table({ columns, data, className, disableSortRemove = false }) {
	const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
		useTable(
			{
				columns,
				data,
				disableSortRemove,
			},
			useSortBy,
		);

	const getTableTitlesAndSetThemLikeDataAttrOnTd = () => {
		const tables = document.querySelectorAll("table");

		for (const table of tables) {
			const tableRows = table.querySelectorAll("tr");
			const th = table.querySelectorAll("th");

			for (const tableRow of tableRows) {
				const tds = tableRow.querySelectorAll("td");

				for (const [index, td] of tds.entries()) {
					td.setAttribute("data-title", th[index].textContent);
				}
			}
		}
	};

	useEffect(() => {
		getTableTitlesAndSetThemLikeDataAttrOnTd();
	});

	return (
		<div className={cx("table", className)}>
			<table {...getTableProps()}>
				<thead>
					{headerGroups.map((headerGroup) => (
						<tr {...headerGroup.getHeaderGroupProps()}>
							{headerGroup.headers.map((column) => {
								let columnProps = column.getHeaderProps();
								const sortableClassNames = cx([
									column.isSorted && column?.isSortable
										? column.isSortedDesc
											? "desc"
											: "asc"
										: "",
								]);

								if (column?.isSortable) {
									columnProps = column.getHeaderProps(
										column.getSortByToggleProps(),
									);
								}

								const image = column.Icon && (
									<img src={column.Icon} alt="" />
								);

								return (
									<th
										className={sortableClassNames}
										{...columnProps}
									>
										<div className="table__th">
											{column.render("Header")}
											{image}
										</div>
									</th>
								);
							})}
						</tr>
					))}
				</thead>
				<tbody {...getTableBodyProps()}>
					{rows.map((row, i) => {
						prepareRow(row);
						return (
							<tr {...row.getRowProps()} id={i}>
								{row.cells.map((cell) => {
									return (
										<td {...cell.getCellProps()}>
											{cell.render("Cell")}
										</td>
									);
								})}
							</tr>
						);
					})}
				</tbody>
			</table>
		</div>
	);
}

export default Table;
